export class Stage {
  stageName = "";
  stageNr = 0;
  zoneNr = 0;
}